export class WidgetModelPinPreference {
    constructor(widgetInstance) {
        this.id = widgetInstance.widgetId;
        this.instanceId = widgetInstance.instanceId;
        this.widgetDefinitionId = widgetInstance.widgetDefinitionId;
        this.size = widgetInstance.getWidgetProperty("size");
        this.column = widgetInstance.getWidgetProperty("column") === "primary" ? 0 : 1;
        this.position = widgetInstance.getWidgetProperty("position");
    }
}
